// CSRF
module.exports.CSRF_COOKIE_NAME = 'LEI-XSRF-TOKEN';
